export const environment = {
  versionDetectionPollInSeconds: 300,
  production: true,
  apiUrl: '/api'
};
